import { ActivatedRoute } from '@angular/router';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { NgOptimizedImage } from '@angular/common';
import { MessageComponent, MessageType, WINDOW } from '@sfcu/sfc-front-starter';
import { BtnRetourComponent } from '../btn-retour/btn-retour.component';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    imports: [NgOptimizedImage, MessageComponent, BtnRetourComponent],
    standalone: true,
})
export class ErrorComponent implements OnInit, OnDestroy {

    private activateRouter$: Subscription;
    public error: any;
    public host: string;

    constructor(private activateRouter: ActivatedRoute,
                @Inject(WINDOW) private window: Window) {

    }

    ngOnInit() {
        this.host = this.window.location?.origin;
        this.activateRouter$ = this.activateRouter
            .queryParams
            .subscribe(query => {
                this.error = JSON.parse(query[ 'error' ]);
            });
    }

    ngOnDestroy(): void {
        this.activateRouter$.unsubscribe();
    }

    protected readonly MessageType = MessageType;
}
